import React, { useState } from "react";
import config from "../../config";
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
} from "@mui/material";
import axios from "axios";
import { toast } from 'react-toastify';
const company = JSON.parse(sessionStorage.getItem("companyDetails"));
export default function AgentMaster() {
  const [agentName, setAgentName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [commission, setCommission] = useState("");

  const saveAgent = async () => {
    // ✅ Mandatory validation
    if (!agentName || !commission) {
      toast.error("Agent Name and Commission are required");
      return;
    }

    const token = sessionStorage.getItem("token");
    const companyid = company?.id;
    const payload = {
      agentName,
      mobile: mobile || "",     // optional
      address: address || "",   // optional
      commission,
      companyid,
    };

    try {
      await axios.post(
        `${config.API_BASE_URL}/Home/CreateAgent`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Agent created successfully!");

      // reset form
      setAgentName("");
      setMobile("");
      setAddress("");
      setCommission("");
    } catch (err) {
      console.error("Error creating agent:", err.response || err);
      toast.error(err.response?.data || "Failed to create agent");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card sx={{ borderRadius: 4, p: 2, boxShadow: 4 }}>
        <CardContent>
          <Typography
            variant="h5"
            align="center"
            sx={{ mb: 3, fontWeight: 700 }}
          >
            Create Agent
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Agent Name *"
              fullWidth
              value={agentName}
              onChange={(e) => setAgentName(e.target.value)}
            />

            <TextField
              label="Mobile Number"
              type="tel"
              inputProps={{ maxLength: 10 }}
              fullWidth
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />

            <TextField
              label="Address"
              multiline
              rows={2}
              fullWidth
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />

            <TextField
              label="Commission (%) *"
              type="number"
              fullWidth
              value={commission}
              onChange={(e) => setCommission(e.target.value)}
            />

            <Button
              variant="contained"
              size="large"
              onClick={saveAgent}
              sx={{ mt: 2 }}
            >
              Save Agent
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
